var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticStyle:{"height":"100vh"}},[_vm._v("PageTwo")])])
}]

export { render, staticRenderFns }